import { createModalHook } from '../../hooks/useModal'

export const usePayMonthlyCloseCreditFacilityModal = createModalHook()
